import { useEffect } from "react";
import "./App.scss";
import AppRouter from "./config/AppRouter";
import { isAssesmentLink } from "./config/routeList";
import TagManager from "react-gtm-module";
import ReactCookieBot from "react-cookiebot";

function App() {
  useEffect(() => {
    let gtmId;

    // Example Condition: Use different G-Tags for different routes
    if (isAssesmentLink) {
      gtmId = "G-HVJN7QVWQ4"; // Measurement ID for Checkout
    } else if (window.location.origin === "https://flexgrade.io") {
      gtmId = "G-2L9P57HRD3"; // Default Measurement ID
    }

    // Initialize GTM with the selected G-Tag
    if (gtmId) TagManager.initialize({ gtmId });
  }, []);

  const isMarketing = window.location.origin === "https://flexgrade.io";
  
  return (
    <>
      {isMarketing ? (
        <ReactCookieBot domainGroupId="513c510e-886e-4440-8e4c-e20ffa2b00db" />
      ) : (
        ""
      )}
      <AppRouter />
    </>
  );
}

export default App;
